function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M90.4873 20.5884H86.2849V11.4336H83.8369V22.5675H91.4478C91.5545 22.5675 91.6279 22.4626 91.5879 22.3643L90.9875 20.916C90.9008 20.7129 90.7074 20.5884 90.4873 20.5884Z",
  fill: "#303740"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.2049 11.3086H71.3633L66.0137 22.5866L68.6084 22.5932L69.569 20.6665H76.0059L76.9664 22.567L79.5412 22.5604L74.2249 11.3348L74.2049 11.3086ZM70.3561 18.8251L72.7841 13.5105L75.2254 18.8251H70.3561Z",
  fill: "#303740"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.6029 15.5355C22.6029 13.2157 20.8953 11.3284 18.554 11.2432C18.5006 11.2432 18.4473 11.2432 18.4006 11.2432H11.4834V22.5671H13.9581V19.8278H17.1932L19.241 22.5671H22.096L19.8747 19.5788C21.5623 18.9825 22.6029 17.3966 22.6029 15.5355ZM20.1082 15.5748C20.1082 15.5945 20.1082 15.6076 20.1082 15.6272V15.6338C20.0548 16.9182 19.141 17.9405 17.8202 17.9405H13.9581V13.8841V13.7661V13.3205H17.8202C19.141 13.3205 20.0548 14.1593 20.1082 15.4438V15.4503C20.1082 15.47 20.1082 15.4831 20.1082 15.5027C20.1082 15.5158 20.1082 15.5289 20.1082 15.5421C20.1082 15.5552 20.1082 15.5617 20.1082 15.5748Z",
  fill: "#303740"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.9769 17.5609C59.9769 19.2188 58.6095 20.5622 56.9219 20.5622C55.2343 20.5622 53.8669 19.2188 53.8669 17.5609C53.8669 17.5281 53.8669 11.5254 53.8669 11.5254H51.5122V17.5609C51.5322 20.477 53.9402 22.751 56.9152 22.751C59.8902 22.751 62.2982 20.477 62.3182 17.5609V11.5254H59.9636C59.9702 11.5254 59.9769 17.5019 59.9769 17.5609Z",
  fill: "#303740"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.2437 13.6945H40.1992V22.4758H42.6005V13.6945H46.5494V11.5254H36.2437V13.6945Z",
  fill: "#303740"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.9143 11.3809H28.4663V22.3771H30.9143V11.3809Z",
  fill: "#303740"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80.1111,
  height: 11.5139,
  fill: "white",
  transform: "translate(11.4834 11.2432)"
})));

function SvgRitualLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 34,
    viewBox: "0 0 104 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitualLogo);
export default __webpack_public_path__ + "static/media/Ritual-Logo.da8a5bbc.svg";
export { ForwardRef as ReactComponent };